class PluginFeature {
  id;

  active;

  thirdPartyType;

  featureType;

  enabled;

  constructor(json) {
    this.fromJSON(json);
  }

  fromJSON(res = {}) {
    this.id = res.uuid;
    this.active = res.active;
    this.thirdPartyType = res.thirdPartyType;
    this.featureType = res.featureType;
    this.enabled = res.enabled;
  }
}

export default PluginFeature;
